import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetMenuLoading, EGetMenuActionType } from './types';

export const getMenuLoading: () => TGetMenuLoading = actionGenerator<EGetMenuActionType.Loading>(
  EGetMenuActionType.Loading,
);
